/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useCallback, useEffect, useState } from "react";
import { Typography, useMediaQuery } from "@mui/material";
import { FilterButton, OptionButton } from "src/components/componentes/FilterButton";
import api, { IDataRequest, STATUS_CODE } from "src/framework/providers/api";
// import styles from "./styles";
// import { CardHistorico } from "./CardHistorico";
// import { HistoricoProjeto } from "./HistoricoProjeto";
// import { HistoricoPedido } from "./HistoricoPedido";
// import { HistoricoDesconto } from "./HistoricoDesconto";
// import { HistoricoNotaFiscal } from "./HitoricoNotaFiscal";
import { componentes$, getCidades, getEstruturasDistribuicao } from "src/store/global.store";
import { arrayEquals, arraySort, getEtapaVenda, getEtapaVendaPedido, getPosicaoFileiras, getTipoConexao, getTipoFaturamento, getTipoPagamento, getTipoProjeto } from "./utils/actions";
import { useHistory } from "react-router-dom";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import TabelaComparacaoPedidos from "./TabelaComparacaoPedidos";
import TabelaComparacaoProjetos from "./TabelaComparacaoProjetos";
import TabelaComparacaoDescontos from "./TabelaComparacaoDescontos";
import TabelaComparacaoNotasFiscais from "./TabelaComparacaoNotasFiscais";
import { useObservable } from "src/framework/store/storeUtil";
import { TNotaHistorico, TPedidoHistorico, TProjetoHistorico } from "../../types";
import { ChangeState, ChangeStateDesconto, ChangeStateNotaFiscal, ChangeStatePedido, FIELDS_DESCONTOS, FIELDS_NOTAS, FIELDS_PEDIDOS, FIELDS_PROJETO, INITIAL_CHANGE_STATE, INITIAL_CHANGE_STATE_DESCONTO, INITIAL_CHANGE_STATE_NOTA, INITIAL_CHANGE_STATE_PEDIDO } from "./utils/constants";
import { CardHistoricoNovo } from "./TabelaComparacaoProjetos/CardHistoricoNovo";
import { ContaProvider } from "src/providers/cadastros/ContaProvider";
import moment from "moment";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { OPTION_DESCONTO, OPTION_HISTORICO_ANTIGO, OPTION_HISTORICO_NOVO, OPTION_NOTA_FISCAL, OPTION_PEDIDO, OPTION_PROJETO } from "../Historico";
import theme from "src/theme/light";
import { ID_INVERSOR, ID_MICROINVERSOR, LISTA_INVERSOR_OFFGRID } from "src/components/componentes/types";

export interface IHistorico {
    codigoProjeto: string;
}

export const TIPO_HISTORICO_PROJETO = 1;
export const TIPO_HISTORICO_DESCONTO = 2;
export const TIPO_HISTORICO_PEDIDO = 3;
export const TIPO_HISTORICO_NOTA_FISCAL = 4;
export const ORIGEM_HISTORICO_V1 = 'V1';
export const ORIGEM_HISTORICO_V2 = 'V2';

const TIPOS_HISTORICO_LISTA: OptionButton[] =[
    {
        nome: "Projeto",
        id: TIPO_HISTORICO_PROJETO
    },
    {
        nome: "Desconto",
        id: TIPO_HISTORICO_DESCONTO
    },
    {
        nome: "Pedido",    
        id: TIPO_HISTORICO_PEDIDO
    },
    {
        nome: "Nota fiscal",
        id: TIPO_HISTORICO_NOTA_FISCAL
    },
]

const ORIGEM_HISTORICO_LISTA: OptionButton[] =[
    {
        nome: "Histórico Antigo",
        id: Number(ORIGEM_HISTORICO_V1?.replace(/\D/g, ''))
    },
    {
        nome: "Histórico Novo",
        id: Number(ORIGEM_HISTORICO_V2?.replace(/\D/g, ''))
    },
];

const HistoricoMigrado: FC<IHistorico> = ({ codigoProjeto }) => {
    const history = useHistory();
    // const classes = styles();

    const ORIGEM_DEFAULT = window.location.pathname?.includes('migrados') 
        ? Number(ORIGEM_HISTORICO_V1?.replace(/\D/g, ''))
        : Number(ORIGEM_HISTORICO_V2?.replace(/\D/g, ''));
    
    const [projeto, setProjeto] = useState<any>(null);
    const [pedido, setPedido] = useState<any>(null);
    const [tipoHistorico, setTipoHistorico] = useState<number>(-1);
    const [origemHistorico] = useState<number>(ORIGEM_DEFAULT);
    const [optionOrigemHistorico, setOptionOrigemHistorico] = useState<number>(ORIGEM_DEFAULT);

    // const [descontoAtual, setDescontoAtual] = useState<any>(null);
    // const [historicosProjeto, setHistoricosProjeto] = useState<any[]>([]);
    // const [historicoPedido, setHistoricoPedido] = useState<any[]>([]);
    // const [historicoDesconto, setHistoricoDesconto] = useState<any[]>([]);
    // const [historicoNotaFiscal, setHistoricoNotaFiscal] = useState<any[]>([]);
    // const [projetoSelecionado, seProjetoSelecionado] = useState<number>(-1);
    // const [pedidoSelecionado, setPedidoSelecionado] = useState<number>(-1);
    // const [descontoSelecionado, setDescontoSelecionado] = useState<number>(-1);
    // const [notafiscalSelecionado, setNotafiscalSelecionado] = useState<number>(-1);

    const [projetoHistoricos, setProjetoHistoricos] = useState<any[]>([]);
    const [projetosComparaveis, setProjetosComparaveis] = useState<TProjetoHistorico[]>([]);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [changeState, setChangeState] = useState<ChangeState>(INITIAL_CHANGE_STATE);
    const [pedidosComparaveis, setPedidosComparaveis] = useState<TPedidoHistorico[]>([]);
    const [changeStatePedidos, setChangeStatePedidos] = useState<ChangeStatePedido>(INITIAL_CHANGE_STATE_PEDIDO);
    const [selectedPedidosIds, setSelectedPedidosIds] = useState<number[]>([]);
    const [pedidoHistoricos, setPedidoHistoricos] = useState<any[]>([]);
    const [descontoHistoricos, setDescontoHistoricos] = useState<any[]>([]);
    const [selectedDescontosIds, setSelectedDescontosIds] = useState<number[]>([]);
    const [descontosComparaveis, setDescontosComparaveis] = useState<any[]>([]);
    const [changeStateDescontos, setChangeStateDescontos] = useState<ChangeStateDesconto>(INITIAL_CHANGE_STATE_DESCONTO);
    const [notaFiscalHistoricos, setNotaFiscalHistoricos] = useState<any[]>([]);
    const [selectedNotasFiscaisIds, setSelectedNotasFiscaisIds] = useState<number[]>([]);
    const [notasFiscaisComparaveis, setNotasFiscaisComparaveis] = useState<TNotaHistorico[]>([]);
    const [changeStateNotasFiscais, setChangeStateNotasFiscais] = useState<ChangeStateNotaFiscal>(INITIAL_CHANGE_STATE_NOTA);
    const [optionsHistorico, setOptionsHistorico] = useState<OptionButton[]>([]);
    const permissoes = PermissionUtil.getPermissions();
    const [opcoesHistoricoButton, setOpcoesHistoricoButton] = useState<OptionButton[]>([]);

    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const componentes = useObservable(componentes$);

    const getProjeto = useCallback(async () => {
        const request: IDataRequest = {
            url: `/projetos?codigo_venda=${codigoProjeto}&includes=componentes,componentes.atributos,distribuidor,revenda,disposicao,endereco,descontos,historicos_migrado`,
        }

        const response = await api.get(request);
        if (response.statusCode !== STATUS_CODE.OK && response.statusCode !== STATUS_CODE.NO_CONTENT) {
            return;
        }
    
        const result = response.data[0];
        // const descontos = result?.descontos || [];  
        // const ultimoDesconto = descontos[descontos?.length -1] || null;  

        setProjeto(result);
        // setDescontoAtual(ultimoDesconto);
    }, [codigoProjeto]);

    const getHistoricoProjeto = useCallback(async () => {
        if (!projeto) return [];

        const request: IDataRequest = {
            url: `/historicos/projetos/migrados?projeto_id=${projeto?.id}`,
        }
        const response = await api.get(request);

        if (response.statusCode !== STATUS_CODE.OK && response.statusCode !== STATUS_CODE.NO_CONTENT) {
            return;
        }

        const historicos = projeto?.historicos_migrado || response?.data || [];
        const filterProjetos = historicos?.filter((i:any) => i?.nome_tabela === 'Projetos');
        const projetos = arraySort(filterProjetos, 'realizado_em', 'date');

        const result = projetos?.map((his: any) => {
            const valores = his?.valores;
            const solucaoAgrupada = valores?.SolucaoSugeridaAgrupada;
            let componentes = solucaoAgrupada?.length 
                ? solucaoAgrupada?.map((rec: any) => {
                    const codigoProjeto = valores?.Componentes?.find((c: any) => c.ProdutoId === rec.ProdutoId)?.CodigoProduto || 0;
                    return ({
                        componente_id: Number(codigoProjeto),
                        quantidade: rec.Quantidade,
                        valor_unitario: rec.ValorFinal,
                        valor_unitario_original: rec.ValorSemImposto,
                    })
                }) : valores?.Componentes?.map((rec: any) => ({
                    componente_id: Number(rec.CodigoProduto),
                    quantidade: rec.Quantidade,
                    valor_unitario: rec.ValorFinal,
                    valor_unitario_original: rec.Valor,
                }));

            const correlacao = his?.correlacao_id;
            const consumosV1 = historicos?.find((i:any) => i?.nome_tabela === 'ConsumosEnergia' && i?.correlacao_id === correlacao);
            const consumo = consumosV1?.valores?.map((i: any) => ({ 
                dia: String(new Date(i?.Data)),
                consumo: String(i?.ConsumoPonta),
            })) || [];

            const disposicoesV1 = historicos?.find((i:any) => i?.nome_tabela === 'DisposicoesModulos' && i?.correlacao_id === correlacao);
            const fileiras = disposicoesV1?.valores?.map((i: any) => ({ 
                posicao: getPosicaoFileiras(i?.Disposicao),
                estrutura_id: i?.TipoEstruturaId ? i?.TipoEstruturaId : 0,
                fileiras_iguais: i?.Linhas,
                modulos_sequencia: String(i?.Modulos),
            })) || [];

            const configuracaoSistemaV1 = valores?.Configuracao;
            const solucao_sugerida = {
                fator_perdas: configuracaoSistemaV1?.FatorDePerdas,
                potencia: configuracaoSistemaV1?.Potencia,
                inversor: configuracaoSistemaV1?.TipoInversor,
                tipo_inversor: configuracaoSistemaV1?.TipoInversor,
                inversor_tensao: configuracaoSistemaV1?.Tensao,
                inversor_tipo_conexao: getTipoConexao(configuracaoSistemaV1?.Fase),
                tipo_projeto: Number(configuracaoSistemaV1?.GrupoTensao) === 2 ?  "grupo-a" : "grupo-b",
                consumo,
                fileiras,
            };

            const comissao = valores?.ComissionamentoDistribuidora || 0;
            const etapaVenda = getEtapaVenda(valores?.EtapaVenda, !!notaFiscalHistoricos?.length);
            const descontos = (valores?.DescontoProjeto?.PercentualTotal || (valores?.DescontoProjeto?.PercentualDesconto || 0) + (valores?.DescontoProjeto?.PercentualDescontoIntelbras || 0) + (valores?.DescontoProjeto?.PercentualTotal || 0));
            const descontoProjeto = (valores?.Valor || 0) * ((descontos/100) || 0);
            const valorDesconto = (valores?.DescontoProjeto?.ValorDesconto || 0) + (descontoProjeto || 0) + (valores?.ValorDescontoCupom || 0);
            const valorPisCofins = valores?.ValordeServicoComPisCofins || 0;
            const valorProjeto = Number((valores?.Valor - valorDesconto) + valorPisCofins);

            const distribuidorId = valores?.distribuidor_id || valores?.DistribuidorId;
            const revendaId = valores?.revenda_id | valores?.RevendaId;

            const result = {     
                componentes,                                                   // Componentes
                codigo_venda: codigoProjeto,                                   // Código Projeto
                titulo: valores.Titulo,                                        // Título
                created_at: his?.realizado_em,                                 // Realizado Em
                distribuidor: valores?.distribuidor?.nome,                     // Distribuidor
                distribuidor_id: distribuidorId,                               // Distribuidor
                revenda: valores?.revenda?.nome,                               // Revenda
                revenda_id: revendaId,                                         // Revenda
                etapa_venda: etapaVenda,                                       // Etapa de venda
                status_projeto: etapaVenda,                                    // Status do Projeto
                status_projeto_pagamento: "",                                  // Status Pagamento Projeto
                data_expiracao: valores?.DataDeExpiracao,                      // Expirado
                tipo: getTipoProjeto(codigoProjeto, valores),                  // Tipo de projeto
                tipo_faturamento: getTipoFaturamento(valores?.OpcaoVenda),     // Tipo de cliente
                tipo_proposta: getTipoPagamento(valores?.TipoPagamento),       // Tipo de pagamento
                visita_tecnica_texto_id: null,                                 // Aceitou os termos
                preco_kwh: configuracaoSistemaV1?.PrecoKwhPonta,               // Preço do kWh
                potencia: configuracaoSistemaV1?.PotenciaGerador,              // Potência do gerador
                potencia_desejada: configuracaoSistemaV1?.Potencia,            // Potência desejada
                consumo: consumo?.length,                                      // Consumo
                fator_perda: configuracaoSistemaV1?.FatorDePerdas,             // Fator de perdas (%)
                disposicao: fileiras?.length,                                  // Disposição dos módulos
                tensao: configuracaoSistemaV1?.Tensao,                         // Tensão
                fase: configuracaoSistemaV1?.Fase,                             // Fase
                tipo_inversor: configuracaoSistemaV1?.TipoInversor,            // Tipo Inversor
                estrutura: fileiras?.length,                                   // Tipo de estrutura
                solucao_sugerida: solucao_sugerida || [],                      // Solução sugerida
                cliente_proposta: valores?.NomeCliente,                        // Nome
                cpf_cnpj_proposta: valores?.Cpf,                               // CPF/CNPJ
                email_proposta: valores?.Email,                                // E-mail
                endereco_proposta: valores?.Endereco?.EnderecoFormatado,       // Endereço
                valor_margem_produtos: valores?.ValorMargemProdutos || 0,      // Valor Margem
                valor_servico: valores?.ValorInstalacao || 0,                   // Valor Serviço
                valor_servico_pis_cofins: valorPisCofins || 0,                 // Valor Serviço
                valor_produtos: valores?.Valor,                                // Valor Produtos
                valor: valores?.Valor,                                         // Valor Produtos
                valor_projeto: valorProjeto,                                   // Valor Projeto
                valor_desconto: valorDesconto,                                 // Valor Desconto
                percentual_comissao_distribuidor: comissao,                    // Comissão Projeto
                usuario: getNomeCompleto(valores?.usuario) || "SISTEMA",       // Usuário
                cidade: valores?.cidade,                                       // Cidade
                cidade_id: valores?.cidade?.id,                                // Cidade
                endereco: {                                                    // Endereço
                    bairro: valores?.Endereco?.Bairro,
                    cep: String(valores?.Endereco?.Cep || ''),
                    logradouro: valores?.Endereco?.Logradouro,
                    numero: valores?.Endereco?.Numero,
                    latitude: valores?.Endereco?.Latitude,
                    longitude: valores?.Endereco?.Longitude,
                    cidade_id: valores?.cidade?.id,
                    estado_id: valores?.estado?.sigla,
                },

                simultaneidade: "",                                             // Simultaneidade
                estabelecimento: valores?.Estabelecimento,                      // Estabelecimento
                nome_modulo: "",                                                // Nome do módulo
                aceitou_nao_incluir_estruturas: true,                           // Aceitou não incluir estruturas
                previsao_faturamento: valores?.TextoAceito,                     // Previsão de faturamento
                termos_aceite: valores?.TextoConfirmarVisitaTecnica,            // Termos
                dados_termo: {                                                  // Dados Termos
                    aceito_em: valores?.DataProjetoAceito,
                    texto: valores?.TextoAceito,
                    usuario: valores?.CriadoPor
                },                                              
                dados_visita_tecnica: {                                         // Dados Visita Técnica
                    aceito_em: valores?.DataVisitaTecnica,
                    texto: valores?.TextoConfirmarVisitaTecnica,
                    usuario: valores?.VisitaTecnicaConfirmadaPor
                },                                              
            }

            return {
                projeto: result,
                projeto_id: projeto?.id,
                data_alteracao: his?.realizado_em,
                usuario: getNomeCompleto(valores?.usuario) || "SISTEMA",
                listar_historico: true, 
                id: correlacao, 
                operacao: his?.situacao,
                historico_id: correlacao, 
            };
        });

        const contasProvider = new ContaProvider();
        for await (const item of result){
            if (!item?.projeto?.distribuidor && item?.projeto?.distribuidor_id) {
                await contasProvider.getUsuarioConta(item?.projeto?.distribuidor_id).then(response => {
                    item.projeto.distribuidor = response?.nome;
                });
            }
    
            if (!item?.projeto?.revenda && item?.projeto?.revenda_id) {
                await contasProvider.getUsuarioConta(item?.projeto?.revenda_id).then(response => {
                    item.projeto.revenda = response?.nome;
                });
            }
        }

        setProjetoHistoricos(result);
    }, [projeto, notaFiscalHistoricos, codigoProjeto]);

    const getNomeCompleto = useCallback((usuario) => {
        if (!usuario?.Nome || !usuario?.Sobrenome) return usuario?.NomeContato;
        return `${usuario?.Nome} ${usuario?.Sobrenome}`;
    }, []);

    const getHistoricoProjetoDesconto = useCallback(async () => {
        if(projeto){
            const request: IDataRequest = {
                url: `/historicos/projetos/migrados/descontos?projeto_id=${projeto?.id}`,
            }
            const response = await api.get(request);
    
            if (response.statusCode !== STATUS_CODE.OK && response.statusCode !== STATUS_CODE.NO_CONTENT) {
                return;
            }
    
            const dados = response.data;
            const historicos = arraySort(dados, 'realizado_em', 'date');
            const result = historicos?.map((i: any) => ({
                justificativa: i?.valores?.Justificativa,
                valor_intelbras: i?.valores?.ValorDesconto,
                percentual_intelbras: "",
                percentual_distribuidor: i?.valores?.PercentualDesconto,
                percentual_revenda: i?.valores?.PercentualDescontoIntelbras,
                desconto_total: i?.valores?.PercentualDesconto + i?.valores?.PercentualDescontoIntelbras,
                usuario: getNomeCompleto(i?.valores?.usuario) || "SISTEMA",
    
                id: i?.id, 
                projeto_id: i?.projeto_id,
                operacao: i?.tipo_operacao,
                historico_id: i?.desconto_id, 
                created_at: i?.realizado_em,
            }));
    
            setDescontoHistoricos(result);
        }
    }, [projeto, tipoHistorico]);

    const getHistoricoPedido = useCallback(async () => {
        if (!pedido) return [];

        const request: IDataRequest = {
            url: `/historicos/pedidos/migrados?pedido_id=${pedido?.id}`,
        }
        const response = await api.get(request);
    
        if (response.statusCode !== STATUS_CODE.OK && response.statusCode !== STATUS_CODE.NO_CONTENT) {
            return;
        }

        const dados = response.data;
        const historicos = arraySort(dados, 'realizado_em', 'date');
        const result = historicos?.map((i: any) => ({
            id: i?.id, 
            pedido_id: pedido?.id,
            operacao: i?.situacao,
            historico_id: i?.identificador, 
            data_alteracao: i?.realizado_em,
            listar_historico: true,
            usuario: getNomeCompleto(i?.valores?.usuario) || "SISTEMA",
            pedido: {
                data_previsao_faturamento: i?.valores?.DataFaturamentoPagamento,
                pedido_erp: i?.valores?.NumeroPedido,
                valor_pedido: i?.valores?.ValorTotalPedido,
                data_emissao: i?.valores?.DataEmissao,
                etapa_pedido: getEtapaVendaPedido(projeto?.etapa_venda, (i?.valores?.DataEmissao !== null)),
                created_at: i?.realizado_em,
                items: projeto?.componentes,
                transportadora: i?.valores?.Transportadora,
                nome_transportadora: i?.valores?.NomeTransportadora,
                situacao: i?.valores?.Situacao,
                situacao_avaliacao: i?.valores?.SituacaoAvaliacao,
                rastreamentos: pedido?.rastreamentos,
                componentes: projeto?.componentes,
                termos_aceite: null,
            },
        }));
    
        setPedidoHistoricos(result)
    }, [pedido, projeto, tipoHistorico]);

    const getPedido = useCallback(async () => { 
        const request: IDataRequest = {
            url: `/vendas/pedidos/?codigo_venda=${codigoProjeto}&includes=rastreamentos,termos_aceite,notas_fiscais,notas_fiscais.itens`,
        }
        const response = await api.get(request);

        if (response.statusCode !== STATUS_CODE.OK && response.statusCode !== STATUS_CODE.NO_CONTENT) {
            return;
        }

        const pedido = response.data[0];
        setPedido(pedido);

     }, [codigoProjeto, tipoHistorico])

    const getHistoricoNotaFiscal = useCallback(async () => {
        if (!pedido) return [];

        const request: IDataRequest = {
            url: `/historicos/pedidos/migrados/notas_fiscais?pedido_id=${pedido?.id}}&includes=itens`,
        }
        const response = await api.get(request);
    
        if (response.statusCode !== STATUS_CODE.OK && response.statusCode !== STATUS_CODE.NO_CONTENT) {
            return;
        }
    
        const dados = response.data;
        const historicos = arraySort(dados, 'realizado_em', 'date');
        const result = historicos?.map((i: any) => {
            const enderecoHistorico = i?.valores?.EnderecoEntregaHistorico;
            const endereco = (Array.isArray(enderecoHistorico) ? enderecoHistorico?.pop() : enderecoHistorico);

            const componentes = i?.itens?.reduce(
                (results:any, current:any) => ({
                  ...results,
                  [current.codigo_produto]: {...current}
                }),
                {}
            );
            const itens = Object.values(componentes)?.length ? Object.values(componentes) : i?.itens;

            return {
                numero: Number(i?.valores?.NumeroNotaFiscal || 0),
                valor: Number(i?.valores?.ValorTotal || 0),
                created_at: i?.realizado_em,
                itens: itens?.map((item: any) => ({
                    codigo: item?.valores?.CodigoProduto,
                    nome: item?.valores?.NomeProduto,
                    quantidade: Number(item?.valores?.Quantidade) || 1,
                    valor: Number(item?.valores?.ValorTotal) || 0,
                })),
    
                peso_bruto: Number(i?.valores?.PesoBruto || 0),
                observacao: i?.valores?.Observacao || "",
                
                cidade: endereco?.Cidade || "",
                estado: endereco?.Estado || "",
                uf: endereco?.UF || "",
                cep: endereco?.CEP || "",
                bairro: endereco?.Bairro || "",
                logradouro: endereco?.Logradouro || "",
                numero_endereco: endereco?.Numero || "",
                complemento: endereco?.Complemento || "",
    
                id: i?.id, 
                pedido_id: pedido?.id,
                historico_id: i?.identificador,
            }
        });

        setNotaFiscalHistoricos(result)
    }, [pedido, codigoProjeto, tipoHistorico]);

    const getHistoricos = async (_tipoHistorico: number) => {
        // seProjetoSelecionado(-1);
        if (_tipoHistorico === TIPO_HISTORICO_PROJETO) {
            await getHistoricoProjeto();
        }else if(_tipoHistorico === TIPO_HISTORICO_PEDIDO){
            await getHistoricoPedido();
        }else if(_tipoHistorico === TIPO_HISTORICO_DESCONTO){
            await getHistoricoProjetoDesconto();
        }else if(_tipoHistorico === TIPO_HISTORICO_NOTA_FISCAL){
            await getHistoricoNotaFiscal();
        }
    }
    
    const clickButtonFilter = useCallback(async (categorias: number[], nome: string, categoria: string) => {
        // seProjetoSelecionado(-1);
        // setPedidoSelecionado(-1);
        // setDescontoSelecionado(-1);
        const tipoHistorico = categorias?.[0];
        if (tipoHistorico === TIPO_HISTORICO_PROJETO) {
            await getHistoricos(tipoHistorico);
        }
        
        if (tipoHistorico === TIPO_HISTORICO_PEDIDO) {
            await getHistoricoPedido();
            
        }

        if (tipoHistorico === TIPO_HISTORICO_DESCONTO) {
            await getHistoricoProjetoDesconto();
        }

        if (tipoHistorico === TIPO_HISTORICO_NOTA_FISCAL) {
            await getHistoricoNotaFiscal();
        }

        setTipoHistorico(tipoHistorico);
    }, []);

    const handleChangeHistory = useCallback(async (categorias: number[], nome: string, categoria: string) => {
        const selected = opcoesHistoricoButton.find(_tipo => _tipo.nome === categoria)?.id || 0;
        if (selected === 1) history.push(`/projetos/migrados/listagem/historico/${projeto?.codigo_venda}`);
        if (selected === 2) history.push(`/projetos/listagem/historico/${projeto?.codigo_venda}`);
        setOptionOrigemHistorico(selected);
        if(optionsHistorico?.length){
            setTipoHistorico(optionsHistorico[0]?.id);
        }    
    }, [projeto]);

    const handleChangeSelected = (historico_id: number) => {
        if (selectedIds.includes(historico_id)) {
            delete selectedIds[selectedIds.indexOf(historico_id)]
            const projetos = projetosComparaveis.filter(x=>selectedIds.includes(x.id))
            setProjetosComparaveis(projetos);
        } else {
            setSelectedIds(old => [...selectedIds, historico_id ])
            const projetos = projetosComparaveis.filter(x=>selectedIds.includes(x.id))
            setProjetosComparaveis(projetos);
        }
      };

    const handleChangeSelectedPedido = (historico_id: number) => {
        if (selectedPedidosIds.includes(historico_id)) {
            delete selectedPedidosIds[selectedPedidosIds.indexOf(historico_id)]
            const pedidos = pedidosComparaveis.filter(x=>selectedPedidosIds.includes(x.id))
            setPedidosComparaveis(pedidos);
        } else {
            setSelectedPedidosIds(old => [...selectedPedidosIds, historico_id ])
            const pedidos = pedidosComparaveis.filter(x=>selectedPedidosIds.includes(x.id))
            setPedidosComparaveis(pedidos);
        }
    };
    const handleChangeSelectedDesconto = (historico_id: number)=>{
        if (selectedDescontosIds.includes(historico_id)) {
            delete selectedDescontosIds[selectedDescontosIds.indexOf(historico_id)]
            const descontos = descontosComparaveis.filter(x=>selectedDescontosIds.includes(x.id))
            setDescontosComparaveis(descontos);
        } else {
            setSelectedDescontosIds(old => [...selectedDescontosIds, historico_id ])
            const descontos = descontosComparaveis.filter(x=>selectedDescontosIds.includes(x.id))
            setDescontosComparaveis(descontos);
        }
    }

    const handleChangeSelectedNotaFiscal = (historico_id: number)=>{
        if (selectedNotasFiscaisIds.includes(historico_id)) {
            delete selectedNotasFiscaisIds[selectedNotasFiscaisIds.indexOf(historico_id)]
            const notas = notasFiscaisComparaveis.filter(x=>selectedNotasFiscaisIds.includes(x.id))
            setNotasFiscaisComparaveis(notas);
        } else {
            setSelectedNotasFiscaisIds(old => [...selectedNotasFiscaisIds, historico_id ])
            const notas = notasFiscaisComparaveis.filter(x=>selectedNotasFiscaisIds.includes(x.id))
            setNotasFiscaisComparaveis(notas);
        }
    }
    
    const getListaHistorico = () =>  {
        if (tipoHistorico === TIPO_HISTORICO_PROJETO) {
            return projetoHistoricos.map((_historicoProjeto, _index) =>{
                return {
                    index: _index,
                    created_at: _historicoProjeto.data_alteracao,
                    usuario: _historicoProjeto?.usuario,
                    valor: ((_historicoProjeto?.projeto?.valor || 0) - (_historicoProjeto?.projeto?.valor_desconto || 0) + (_historicoProjeto?.projeto?.valor_servico_pis_cofins || 0)) || (_historicoProjeto?.projeto?.valor_projeto || 0),
                    historico_id: _historicoProjeto.id,
                }
            })
        }
        
        if (tipoHistorico === TIPO_HISTORICO_PEDIDO) {
            return pedidoHistoricos.map((_historicoPedido, _index) => {
                return {
                    index: _index,
                    created_at: _historicoPedido?.data_alteracao,
                    usuario: null,
                    valor: (_historicoPedido?.pedido?.valor_pedido || 0) - (_historicoPedido?.pedido?.valor_desconto || 0),
                    historico_id: _historicoPedido.id,
                }
            });
        }
        if (tipoHistorico === TIPO_HISTORICO_DESCONTO) {
            return descontoHistoricos.map((_historicoDesconto, _index)=>{
                return {
                    index: _index,
                    created_at: _historicoDesconto?.created_at,
                    usuario: _historicoDesconto?.usuario,
                    historico_id: _historicoDesconto.id,
                }
            })
        }
        if (tipoHistorico === TIPO_HISTORICO_NOTA_FISCAL) {
            return notaFiscalHistoricos.map((_historicoNota, _index)=>{
                return {
                    index: _index,
                    created_at: _historicoNota?.updated_at || _historicoNota?.created_at,
                    historico_id: _historicoNota?.id,
                    valor: _historicoNota.valor,
                }
            })
        }

        return [];
    }
    useEffect(()=>{
        if(permissoes.includes("*")){
            setOptionsHistorico(TIPOS_HISTORICO_LISTA);
        }else{
            const options: OptionButton[]=[]
            if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_PROJETOS, permissoes)){
                options.push(OPTION_PROJETO)
            }
            if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_PEDIDOS, permissoes)){
                options.push(OPTION_PEDIDO)
            }
            if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_DESCONTOS, permissoes)){
                options.push(OPTION_DESCONTO)
            }
            if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_NOTAS_FISCAIS, permissoes)){
                options.push(OPTION_NOTA_FISCAL)
            }
            setOptionsHistorico(options);
            /*if(options?.length){
                setTipoHistorico(options[0].id);
            }*/
        }
    },[])
    useEffect(()=>{
        if(permissoes.includes("*")){
            setOpcoesHistoricoButton(ORIGEM_HISTORICO_LISTA);
            //setOptionOrigemHistorico(2);
        }else{
            const options: OptionButton[]=[];
            if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_ANTIGO, permissoes)){
                options.push(OPTION_HISTORICO_ANTIGO);
                //setOptionOrigemHistorico(1);
            }
            if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_PROJETOS, permissoes)
            || PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_PEDIDOS, permissoes)
            || PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_DESCONTOS, permissoes)
            || PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_NOTAS_FISCAIS, permissoes)){
                options.push(OPTION_HISTORICO_NOVO);
                //setOptionOrigemHistorico(2);
            }
            if(!options?.length){
                setTipoHistorico(-1);
            }
            setOpcoesHistoricoButton(options);
        }
    },[handleChangeHistory])

    useEffect(()=>{
        (async ()=>{
            if(optionsHistorico?.length){
                if(tipoHistorico === -1){
                    setTipoHistorico(optionsHistorico[0]?.id || -1)
                }else{
                    setTipoHistorico(tipoHistorico)
                }
                await getHistoricos(optionsHistorico[0]?.id || tipoHistorico);
            }
        })()
    },[optionsHistorico, opcoesHistoricoButton])
    useEffect(() => {
        const loadRequests = async () => {
            await getEstruturasDistribuicao();
            await getCidades();
            await getProjeto();
            await getPedido();
            await getHistoricos(tipoHistorico);
        }

        loadRequests();
    }, [tipoHistorico, origemHistorico]);

    useEffect(() => {
        const loadRequests = async () => {
            await getHistoricos(tipoHistorico);
        }

        loadRequests();
    }, [projeto]);

    useEffect(()=>{
        const projetosComp = projetoHistoricos.filter(x=>selectedIds.includes(x.id))
        setProjetosComparaveis(old => projetosComp);
    },[selectedIds])

    useEffect(()=>{
        const pedidosComp = pedidoHistoricos.filter(x=>selectedPedidosIds.includes(x.id))
        setPedidosComparaveis(old => pedidosComp);
    },[selectedPedidosIds])

    useEffect(()=>{
        const descontosComp = descontoHistoricos.filter(x=>selectedDescontosIds.includes(x.id))
        setDescontosComparaveis(old => descontosComp);
    },[selectedDescontosIds])

    useEffect(()=>{
        const notasComp = notaFiscalHistoricos.filter(x=>selectedNotasFiscaisIds.includes(x.id))
        setNotasFiscaisComparaveis(old => notasComp);
    },[selectedNotasFiscaisIds])

    useEffect(()=>{
        if (projetosComparaveis.length) {
            const changes = { ...changeState }            
            for (const field of FIELDS_PROJETO) {
                let equal = true;
                switch (field) {
                    case "solucao_sugerida":
                        const _projetos = projetosComparaveis;
                        for (let i=0;i<_projetos?.length;i++) {
                            if (_projetos[i]?.projeto?.solucao_sugerida) {
                                const solucaoAtual = _projetos[i].projeto?.solucao_sugerida?.componentes?.filter((i: any)=>i.quantidade > 0);
                                const primeiraSolucao = _projetos[0].projeto?.solucao_sugerida?.componentes?.filter((i: any)=>i.quantidade > 0);
                                solucaoAtual?.sort((a: any, b: any)=> a.id - b.id);
                                primeiraSolucao?.sort((a: any, b: any)=> a.id - b.id);
                                equal = JSON.stringify(solucaoAtual?.map((c:any)=>{
                                    return {
                                        id: c.id,
                                        quantidade: c.quantidade
                                    }
                                }))?.toString() === JSON.stringify(primeiraSolucao?.map((cm:any)=>{
                                    return {
                                        id: cm.id,
                                        quantidade: cm.quantidade
                                    }
                                }))?.toString();
    
                                if (!equal) {
                                    break;
                                }
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "componentes":
                        const projetos = projetosComparaveis;

                        for (let i=0;i<projetos?.length;i++) {
                            if (projetos[i].projeto?.componentes) {
                                projetos[i].projeto?.componentes?.sort((a, b) => a.componente_id - b.componente_id)
                                equal = JSON.stringify((projetos[i].projeto?.componentes)?.map(c=>{
                                    return {
                                        id: c.componente_id,
                                        quantidade: c.quantidade
                                    }
                                }))?.toString() === JSON.stringify((projetos[0].projeto?.componentes)?.map(cm=>{
                                    return {
                                        id: cm.componente_id,
                                        quantidade: cm.quantidade
                                    }
                                }))?.toString();
    
                                if (!equal) {
                                    break;
                                }
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "termos_aceite":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i].projeto?.termos_aceite) {

                                equal = JSON.stringify(projetosComparaveis[i]?.projeto?.[field]) === JSON.stringify(projetosComparaveis[0]?.projeto?.[field])
    
                                if (!equal) {
                                    break;
                                }
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_produtos":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i].projeto?.valor) {

                                equal = projetosComparaveis[i].projeto?.valor === projetosComparaveis[0].projeto?.valor;
    
                                if (!equal) {
                                    break;
                                }
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_produtos_desconto":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i].projeto?.valor) {
                                equal = ((projetosComparaveis[i].projeto?.valor || 0) - (projetosComparaveis[i].projeto?.valor_desconto || 0)) === ((projetosComparaveis[0].projeto?.valor || 0) - (projetosComparaveis[0].projeto?.valor_desconto || 0));
    
                                if (!equal) {
                                    break;
                                }
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_instalacao":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            equal = projetosComparaveis[i].projeto?.valor_servico === projetosComparaveis[0].projeto?.valor_servico;
                            if (!equal) {
                                break;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_margem":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            equal = projetosComparaveis[i].projeto?.valor_margem_produtos === projetosComparaveis[0].projeto?.valor_margem_produtos;
                            if (!equal) {
                                break;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "consumo":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i]?.projeto?.solucao_sugerida?.consumo?.length) {
                                const formatValue = arraySort(projetosComparaveis[0]?.projeto?.solucao_sugerida?.consumo, 'dia', 'date')?.map((i:any) => `${moment(i?.dia).format("MM/YYYY")}-${i?.consumo}`);
                                const formatValueAtual = arraySort(projetosComparaveis[i]?.projeto?.solucao_sugerida?.consumo, 'dia', 'date')?.map((i:any) => `${moment(i?.dia).format("MM/YYYY")}-${i?.consumo}`);

                                equal = arrayEquals(formatValue, formatValueAtual);
                                
                                if (!equal) {
                                    break;
                                }
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "disposicao":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i]?.projeto?.solucao_sugerida?.fileiras) {
                                equal = JSON.stringify(projetosComparaveis[i]?.projeto?.solucao_sugerida?.fileiras) === JSON.stringify(projetosComparaveis[0]?.projeto?.solucao_sugerida?.fileiras);
                                
                                if (!equal) {
                                    break;
                                }
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "previsao_faturamento":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i]?.projeto?.previsao_faturamento) {
                                if (JSON.stringify(projetosComparaveis[i]?.projeto?.previsao_faturamento) !== JSON.stringify(projetosComparaveis[0]?.projeto?.previsao_faturamento)) {
                                    equal = false;
                                }

                                if (!equal) {
                                    break;
                                }
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "tipo_proposta":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[0]?.projeto?.tipo_proposta && projetosComparaveis[i]?.projeto?.tipo_proposta !== projetosComparaveis[0]?.projeto?.tipo_proposta) {
                                equal = false;
                            }
                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "revenda":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i]?.projeto?.revenda_id) {
                                equal = projetosComparaveis[i]?.projeto?.revenda_id === projetosComparaveis[0]?.projeto?.revenda_id;
                                
                                if (!equal) {
                                    break;
                                }
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "distribuidor":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i]?.projeto?.distribuidor_id) {
                                equal = projetosComparaveis[i]?.projeto?.distribuidor_id === projetosComparaveis[0]?.projeto?.distribuidor_id;
                                
                                if (!equal) {
                                    break;
                                }
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_total":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i].projeto?.valor_projeto) {
                                equal = ((projetosComparaveis[i].projeto?.valor_projeto || 0) - (projetosComparaveis[i].projeto?.valor_desconto || 0)) === ((projetosComparaveis[0].projeto?.valor_projeto || 0) - (projetosComparaveis[0].projeto?.valor_desconto || 0));
                                if (!equal) {
                                    break;
                                }
                            } else {
                                equal = true;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_servico":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if ((projetosComparaveis[0].projeto?.valor_servico === null && projetosComparaveis[i].projeto?.valor_servico === 0) && (projetosComparaveis[0].projeto?.valor_margem_produtos === null && projetosComparaveis[i].projeto?.valor_margem_produtos === 0)) {
                                equal = true;
                            } else if ((projetosComparaveis[0].projeto?.valor_servico === 0 && projetosComparaveis[i].projeto?.valor_servico === null) && (projetosComparaveis[0].projeto?.valor_margem_produtos === 0 && projetosComparaveis[i].projeto?.valor_margem_produtos === null)) {
                                equal = true;
                            } else if ((projetosComparaveis[0].projeto?.valor_servico === null && projetosComparaveis[i].projeto?.valor_servico === null) && (projetosComparaveis[0].projeto?.valor_margem_produtos === null && projetosComparaveis[i].projeto?.valor_margem_produtos === null)) {
                                equal = true;
                            } else {
                                equal = ((projetosComparaveis[i].projeto?.valor_servico === projetosComparaveis[0].projeto?.valor_servico) && (projetosComparaveis[i].projeto?.valor_margem_produtos === projetosComparaveis[0].projeto?.valor_margem_produtos));
                            }      
                            if (!equal) {
                                break;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_servico_pis_cofins":
                        for (let i=0;i<projetosComparaveis?.length;i++) {                            
                            if (projetosComparaveis[0].projeto?.valor_servico_pis_cofins === null && projetosComparaveis[i].projeto?.valor_servico_pis_cofins === 0) {
                                equal = true;
                            } else if (projetosComparaveis[0].projeto?.valor_servico_pis_cofins === 0 && projetosComparaveis[i].projeto?.valor_servico_pis_cofins === null) {
                                equal = true;
                            } else if (projetosComparaveis[0].projeto?.valor_servico_pis_cofins === null && projetosComparaveis[i].projeto?.valor_servico_pis_cofins === null) {
                                equal = true;
                            }else {
                                equal = projetosComparaveis[i].projeto?.valor_servico_pis_cofins === projetosComparaveis[0].projeto?.valor_servico_pis_cofins;
                            }
                            if (!equal) {
                                break;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "preco_kwh":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i].projeto?.preco_kwh) {
                                equal = projetosComparaveis[i].projeto?.preco_kwh === projetosComparaveis[0].projeto?.preco_kwh;
                                if (!equal) {
                                    break;
                                }
                            } else {
                                equal = true;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "simultaneidade":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            equal = Number(projetosComparaveis[i].projeto?.simultaneidade) === Number(projetosComparaveis[0].projeto?.simultaneidade);
                            if (!equal) {
                                break;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "estabelecimento":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i].projeto?.estabelecimento) {
                                equal = projetosComparaveis[i].projeto?.estabelecimento === projetosComparaveis[0].projeto?.estabelecimento;
                                if (!equal) {
                                    break;
                                }
                            } else {
                                equal = true;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "aceitou_termos":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i].projeto?.origem === ORIGEM_HISTORICO_V1) {
                                equal = String(projetosComparaveis[i].projeto?.dados_migracao?.projetoV1?.AceitouOsTermos) === String(projetosComparaveis[0].projeto?.dados_migracao?.projetoV1?.AceitouOsTermos);
                            } else {
                                equal = String (projetosComparaveis[i].projeto?.dados_termo?.aceito_em) === String(projetosComparaveis[0].projeto?.dados_termo?.aceito_em);
                            }
                            if (!equal) {
                                break;
                            }                            
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "endereco":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i].projeto?.endereco?.cidade_id !== projetosComparaveis[0].projeto?.endereco?.cidade_id) {
                                equal = false;
                            } else if (projetosComparaveis[i].projeto?.endereco?.bairro !== projetosComparaveis[0].projeto?.endereco?.bairro) {
                                equal = false;
                            } else if (projetosComparaveis[i].projeto?.endereco?.complemento !== projetosComparaveis[0].projeto?.endereco?.complemento) {
                                equal = false;
                            } else if (projetosComparaveis[i].projeto?.endereco?.cep !== projetosComparaveis[0].projeto?.endereco?.cep) {
                                equal = false;
                            } else if (projetosComparaveis[i].projeto?.endereco?.estado_id !== projetosComparaveis[0].projeto?.endereco?.estado_id) {
                                equal = false;
                            } else if (projetosComparaveis[i].projeto?.endereco?.logradouro !== projetosComparaveis[0].projeto?.endereco?.logradouro) {
                                equal = false;
                            } else if (projetosComparaveis[i].projeto?.endereco?.numero !== projetosComparaveis[0].projeto?.endereco?.numero) {
                                equal = false;
                            }
                            if (!equal) {
                                break;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "tensao":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i].projeto?.solucao_sugerida) {
                                equal = projetosComparaveis[i].projeto?.solucao_sugerida?.inversor_tensao === projetosComparaveis[0].projeto?.solucao_sugerida?.inversor_tensao
                            }
                            if (!equal) {
                                break;
                            }
                            
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "concessionaria":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i].projeto?.dados_concessionaria_payback) {
                                equal = projetosComparaveis[i].projeto?.dados_concessionaria_payback?.agente === projetosComparaveis[0].projeto?.dados_concessionaria_payback?.agente;
                            }
                            if (!equal) {
                                break;
                            }                            
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "fator_perdas":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i].projeto?.solucao_sugerida) {
                                equal = projetosComparaveis[i].projeto?.solucao_sugerida?.fator_perdas === projetosComparaveis[0].projeto?.solucao_sugerida?.fator_perdas
                            }
                            if (!equal) {
                                break;
                            }
                            
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "nome_modulo":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            //define se é igual
                            if (projetosComparaveis[i]?.projeto?.componentes) {
                                const moduloAtual = projetosComparaveis[i]?.projeto?.componentes?.filter((_c: any)=>{
                                    const _componenteCache = componentes?.data?.find((c: any)=> c?.id === _c?.componente_id);
                                    return _componenteCache?.categoria_componentes_id === 1;
                                });
                                const primeiroModulo = projetosComparaveis[0]?.projeto?.componentes?.filter((_c: any)=>{
                                    const _componenteCache = componentes?.data?.find((c: any)=> c?.id === _c?.componente_id);
                                    return _componenteCache?.categoria_componentes_id === 1;
                                });
                                const sortedPrimeiroModulo = primeiroModulo?.sort((a, b) => a.componente_id - b.componente_id);
                                const sortedModuloAtual = moduloAtual?.sort((a, b) => a.componente_id - b.componente_id);
                                
                                equal = JSON.stringify((sortedPrimeiroModulo)?.map(c=>{
                                    return {
                                        id: c.componente_id,
                                    }
                                }))?.toString() === JSON.stringify((sortedModuloAtual)?.map(cm=>{
                                    return {
                                        id: cm.componente_id,
                                    }
                                }))?.toString();
                            }
                            if (!equal) {
                                break;
                            }                            
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "inversor_tipo_conexao":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i].projeto?.solucao_sugerida) {
                                equal = projetosComparaveis[i].projeto?.solucao_sugerida?.inversor_tipo_conexao === projetosComparaveis[0].projeto?.solucao_sugerida?.inversor_tipo_conexao
                            }
                            if (!equal) {
                                break;
                            }
                            
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "tipo_inversor":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i]?.projeto?.tipo === "dimensionado" && projetosComparaveis[0]?.projeto?.tipo === "dimensionado") {                                
                                if (projetosComparaveis[i]?.projeto?.solucao_sugerida) {
                                    equal = projetosComparaveis[i]?.projeto?.solucao_sugerida?.tipo_inversor === projetosComparaveis[0]?.projeto?.solucao_sugerida?.tipo_inversor;
                                }
                            } else if ((projetosComparaveis[0]?.projeto?.tipo === "personalizado" || projeto?.tipo === "kit") && (projetosComparaveis[i]?.projeto?.tipo === "personalizado" || projeto?.tipo === "kit")) {
                                if (projetosComparaveis[i]?.projeto?.componentes) {
                                    const inversorAtual = projetosComparaveis[i]?.projeto?.componentes?.find((_c: any) => {
                                        const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.componente_id);
                                        return _componenteCache?.categoria_componentes_id === ID_INVERSOR;
                                    });
            
                                    const microAtual = projetosComparaveis[i]?.projeto?.componentes?.find((_c: any) => {
                                        const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.componente_id);
                                        return _componenteCache?.categoria_componentes_id === ID_MICROINVERSOR;
                                    });

                                    const offgridAtual = projetosComparaveis[i]?.projeto?.componentes?.find((_c: any) => {
                                        const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.componente_id);
                                        return LISTA_INVERSOR_OFFGRID?.includes(_componenteCache?.categoria_componentes_id);

                                    });
    
                                    const inversorPrimeiro = projetosComparaveis[0]?.projeto?.componentes?.find((_c: any) => {
                                        const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.componente_id);
                                        return _componenteCache?.categoria_componentes_id === ID_INVERSOR;
                                    });
            
                                    const microPrimeiro = projetosComparaveis[0]?.projeto?.componentes?.find((_c: any) => {
                                        const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.componente_id);
                                        return _componenteCache?.categoria_componentes_id === ID_MICROINVERSOR;
                                    });

                                    const offgridPrimeiro = projetosComparaveis[0]?.projeto?.componentes?.find((_c: any) => {
                                        const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.componente_id);
                                        return LISTA_INVERSOR_OFFGRID?.includes(_componenteCache?.categoria_componentes_id);

                                    });

                                    if (inversorAtual && inversorPrimeiro) {
                                        equal = true;
                                    } else if (microAtual && microPrimeiro) {
                                        equal = true;
                                    } else if (offgridAtual && offgridPrimeiro) {
                                        equal = true;
                                    } else equal = false;
                                }
                            }
                            if (projetosComparaveis[i]?.projeto?.solucao_sugerida?.inversor === 0 && projetosComparaveis[0]?.projeto?.solucao_sugerida?.inversor === 0) {
                                equal = true;
                            } else if (!equal) {
                                break;
                            }                            
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }

                        break;
                    case "potencia_desejada":
                        for (let i=0;i<projetosComparaveis?.length;i++) {
                            if (projetosComparaveis[i].projeto?.solucao_sugerida?.potencia) {
                                equal = Number(projetosComparaveis[i].projeto?.solucao_sugerida?.potencia) === Number(projetosComparaveis[0].projeto?.solucao_sugerida?.potencia);
                            }
                            if (!equal) {
                                break;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "termos_projeto":
                        for (let i=0;i<projetosComparaveis?.length;i++) {                            
                            equal = JSON.stringify(projetosComparaveis[i].projeto?.dados_termo?.aceito_em) === JSON.stringify(projetosComparaveis[0].projeto?.dados_termo?.aceito_em);

                            if (!equal) {
                                break;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    default:
                        equal = projetosComparaveis.every(
                            (obj: TProjetoHistorico) => obj?.projeto?.[field] === projetosComparaveis[0]?.projeto?.[field]
                        );         
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                }
            }
            setChangeState({ ...changes })
        }
    },[projetosComparaveis])

    useEffect(()=>{
        if (pedidosComparaveis.length) {
            const changes = { ...changeStatePedidos }            
            for (const field of FIELDS_PEDIDOS) {
                let equal = true;
                switch (field) {
                    case "pedido_erp":
                        for (let i=0;i<pedidosComparaveis?.length;i++) {
                            if (pedidosComparaveis[i].pedido?.pedido_erp) {
                                equal = pedidosComparaveis[i].pedido?.pedido_erp === pedidosComparaveis[0].pedido?.pedido_erp;
                                if (!equal) {
                                    break;
                                }
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "data_emissao":
                        for (let i=0;i<pedidosComparaveis?.length;i++) {
                            if (pedidosComparaveis[i].pedido?.data_emissao) {
                                equal = pedidosComparaveis[i].pedido?.data_emissao === pedidosComparaveis[0].pedido?.data_emissao;
                                if (!equal) {
                                    break;
                                }
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_total":
                        for (let i=0;i<pedidosComparaveis?.length;i++) {
                            if (pedidosComparaveis[i].pedido?.valor_pedido) {
                                equal = (pedidosComparaveis[i].pedido?.valor_pedido || 0) - (pedidosComparaveis[i].pedido?.valor_desconto || 0) === (pedidosComparaveis[0].pedido?.valor_pedido || 0) - (pedidosComparaveis[0].pedido?.valor_desconto || 0)
                                if (!equal) {
                                    break;
                                }
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "nome_transportadora":
                        for (let i=0;i<pedidosComparaveis?.length;i++) {
                            if (pedidosComparaveis[i].pedido?.nome_transportadora) {
                                equal = pedidosComparaveis[i].pedido?.nome_transportadora === pedidosComparaveis[0].pedido?.nome_transportadora;
                                if (!equal) {
                                    break;
                                }
                            } else {
                                equal = true;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "transportadora":
                        for (let i=0;i<pedidosComparaveis?.length;i++) {
                            if (pedidosComparaveis[i].pedido?.transportadora) {
                                equal = pedidosComparaveis[i].pedido?.transportadora === pedidosComparaveis[0].pedido?.transportadora;
                                if (!equal) {
                                    break;
                                }
                            } else {
                                equal = true;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "situacao":
                        for (let i=0;i<pedidosComparaveis?.length;i++) {
                            if (pedidosComparaveis[i].pedido?.situacao) {
                                equal = pedidosComparaveis[i].pedido?.situacao === pedidosComparaveis[0].pedido?.situacao;
                                if (!equal) {
                                    break;
                                }
                            } else {
                                equal = true;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "situacao_avaliacao":
                        for (let i=0;i<pedidosComparaveis?.length;i++) {
                            if (pedidosComparaveis[i].pedido?.situacao_avaliacao) {
                                equal = pedidosComparaveis[i].pedido?.situacao_avaliacao === pedidosComparaveis[0].pedido?.situacao_avaliacao;
                                if (!equal) {
                                    break;
                                }
                            } else {
                                equal = true;
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "itens":
                        const pedidos = pedidosComparaveis;
                        for (let i=0;i<pedidos?.length;i++) {
                            if (pedidos[i]?.pedido?.componentes) {
                                pedidos[i]?.pedido?.componentes?.sort((a, b) => a.componente_id - b.componente_id)
                                equal = JSON.stringify((pedidos[i].pedido?.componentes)?.map(c=>{
                                    return {
                                        id: c.componente_id,
                                        quantidade: c.quantidade
                                    }
                                }))?.toString() === JSON.stringify((pedidos[0].pedido?.componentes)?.map(cm=>{
                                    return {
                                        id: cm.componente_id,
                                        quantidade: cm.quantidade
                                    }
                                }))?.toString();
    
                                if (!equal) {
                                    break;
                                }
                            }
                            if (pedidos[i]?.pedido?.nota_fiscal?.itens) {
                                pedidos[i]?.pedido?.nota_fiscal?.itens?.sort((a: any, b: any) => a.componente_id - b.componente_id)
                                equal = JSON.stringify((pedidos[i].pedido?.nota_fiscal?.itens)?.map((c:any)=>{
                                    return {
                                        id: c.componente_id,
                                        quantidade: c.quantidade
                                    }
                                }))?.toString() === JSON.stringify((pedidos[0]?.pedido?.nota_fiscal?.itens)?.map((cm: any)=>{
                                    return {
                                        id: cm.componente_id,
                                        quantidade: cm.quantidade
                                    }
                                }))?.toString();
    
                                if (!equal) {
                                    break;
                                }
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_produtos":
                        for (let i=0;i<pedidosComparaveis?.length;i++) {
                            if (pedidosComparaveis[i].pedido?.valor) {
                                equal = pedidosComparaveis[i].pedido?.valor === pedidosComparaveis[0].pedido?.valor;
                                if (!equal) {
                                    break;
                                }
                            }
                        }

                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;                    
                    default:
                        equal = pedidosComparaveis.every(
                            (obj: TPedidoHistorico) => obj?.pedido?.[field] === pedidosComparaveis[0]?.pedido?.[field]
                        );         
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                }
            }
            setChangeStatePedidos({ ...changes })
        }
    }, [pedidosComparaveis])

    useEffect(()=>{
        if (descontosComparaveis?.length) {
            const changes = { ...changeStateDescontos }            
            for (const field of FIELDS_DESCONTOS) {
                let equal = true;
                switch (field) {
                    case "percentual_distribuidor":
                        for (let i=0;i<descontosComparaveis?.length;i++) {    
                            equal = descontosComparaveis[i]?.percentual_distribuidor === descontosComparaveis[0]?.percentual_distribuidor;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "percentual_revenda":
                        for (let i=0;i<descontosComparaveis?.length;i++) {    
                            equal = descontosComparaveis[i]?.percentual_revenda === descontosComparaveis[0]?.percentual_revenda;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "percentual_intelbras":
                        for (let i=0;i<descontosComparaveis?.length;i++) {    
                            equal = descontosComparaveis[i]?.percentual_intelbras === descontosComparaveis[0]?.percentual_intelbras;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_intelbras":
                        for (let i=0;i<descontosComparaveis?.length;i++) {    
                            equal = descontosComparaveis[i]?.valor_intelbras === descontosComparaveis[0]?.valor_intelbras;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "justificativa":
                        for (let i=0;i<descontosComparaveis?.length;i++) {    
                            equal = descontosComparaveis[i]?.justificativa === descontosComparaveis[0]?.justificativa;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "desconto_total":
                        for (let i=0;i<descontosComparaveis?.length;i++) {    
                            equal = descontosComparaveis[i]?.desconto_total === descontosComparaveis[0]?.desconto_total;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "usuario":
                        for (let i=0;i<descontosComparaveis?.length;i++) {    
                            equal = descontosComparaveis[i]?.usuario === descontosComparaveis[0]?.usuario;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                }
            }
            setChangeStateDescontos({ ...changes })
        }
    },[descontosComparaveis])

    useEffect(()=>{
        if (notasFiscaisComparaveis?.length) {
            const changes = { ...changeStateNotasFiscais }
            for (const field of FIELDS_NOTAS) {
                let equal = true;
                switch (field) {
                    case "valor":
                        for (let i=0;i<notasFiscaisComparaveis?.length;i++) {    
                            equal = notasFiscaisComparaveis[i]?.valor === notasFiscaisComparaveis[0]?.valor;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "numero":
                        for (let i=0;i<notasFiscaisComparaveis?.length;i++) {    
                            equal = notasFiscaisComparaveis[i]?.numero === notasFiscaisComparaveis[0]?.numero;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "peso_bruto":
                        for (let i=0;i<notasFiscaisComparaveis?.length;i++) {    
                            equal = notasFiscaisComparaveis[i]?.peso_bruto === notasFiscaisComparaveis[0]?.peso_bruto;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "estado":
                        for (let i=0;i<notasFiscaisComparaveis?.length;i++) {    
                            equal = notasFiscaisComparaveis[i]?.estado === notasFiscaisComparaveis[0]?.estado;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "bairro":
                        for (let i=0;i<notasFiscaisComparaveis?.length;i++) {    
                            equal = notasFiscaisComparaveis[i]?.bairro === notasFiscaisComparaveis[0]?.bairro;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "cidade":
                        for (let i=0;i<notasFiscaisComparaveis?.length;i++) {    
                            equal = notasFiscaisComparaveis[i]?.cidade === notasFiscaisComparaveis[0]?.cidade;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "complemento":
                        for (let i=0;i<notasFiscaisComparaveis?.length;i++) {    
                            equal = notasFiscaisComparaveis[i]?.complemento === notasFiscaisComparaveis[0]?.complemento;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "numero_endereco":
                        for (let i=0;i<notasFiscaisComparaveis?.length;i++) {    
                            equal = notasFiscaisComparaveis[i]?.numero_endereco === notasFiscaisComparaveis[0]?.numero_endereco;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "itens":
                        for (let i=0;i<notasFiscaisComparaveis?.length;i++) {
                            if (notasFiscaisComparaveis[i]?.itens) {
                                notasFiscaisComparaveis[i]?.itens?.sort((a: any, b: any) => Number(a.codigo) - Number(b.codigo));
                                equal = JSON.stringify((notasFiscaisComparaveis[i]?.itens)?.map(c=>{
                                    return {
                                        id: c.codigo,
                                        quantidade: c.quantidade
                                    }
                                }))?.toString() === JSON.stringify((notasFiscaisComparaveis[0]?.itens)?.map(cm=>{
                                    return {
                                        id: cm.codigo,
                                        quantidade: cm.quantidade
                                    }
                                }))?.toString();
    
                                if (!equal) {
                                    break;
                                }
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "logradouro":
                        for (let i=0;i<notasFiscaisComparaveis?.length;i++) {    
                            equal = notasFiscaisComparaveis[i]?.numero_endereco === notasFiscaisComparaveis[0]?.numero_endereco;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "observacao":                        
                        for (let i=0;i<notasFiscaisComparaveis?.length;i++) {    
                            equal = notasFiscaisComparaveis[i]?.observacao === notasFiscaisComparaveis[0]?.observacao;

                            if (!equal) {
                                break;
                            }
                        }
                        if (!equal) {
                            changes[field] = {hasChanged: true}
                        } else {
                            changes[field] = {hasChanged: false}
                        }
                        break;
                }
            }
            setChangeStateNotasFiscais({ ...changes })
        }
    },[notasFiscaisComparaveis])

    return <div className="Historico">
        <div className="row" style={isMobile ? { marginTop: 20 } : {}}>
            <div className="X12" style={{ display: "flex", marginBottom: 15, marginTop: 15 }}>
                <FlatButton
                    text="Voltar"
                    onClick={() => history.replace('/projetos/menu-projetos')}
                    variant="outlined"
                />
            </div>
            <div className="X12" style={{display: "flex"}}>
                <Typography variant="h6" style={{ fontWeight: "bold", textAlign: "left"}}>
                Projeto Migrado - {projeto?.codigo_venda}
                </Typography>
            </div>
        </div>

        <div className="row">
            <div className="X12" style={{display: "flex"}}>
                {/*<FilterButton 
                    nome={TIPOS_HISTORICO_LISTA.find(_tipo => _tipo.id === tipoHistorico)?.nome || ""} 
                    options={TIPOS_HISTORICO_LISTA} 
                    handleClickButton={clickButtonFilter}
                    containerStyles={{alignContent: "flex-start", width: 'auto', marginRight: 30}}
                />*/}
                {optionsHistorico?.length > 0 && (
                    <FilterButton 
                        nome={optionsHistorico.find(_tipo => _tipo.id === tipoHistorico)?.nome || ""} 
                        options={optionsHistorico} 
                        handleClickButton={clickButtonFilter}
                        containerStyles={{alignContent: "flex-start", width: 'auto', marginRight: 30}}
                    />)
                }

                { projeto?.origem === ORIGEM_HISTORICO_V1 && (
                    <FilterButton 
                        nome={opcoesHistoricoButton.find(_tipo => _tipo.id === optionOrigemHistorico)?.nome || ""} 
                        options={opcoesHistoricoButton} 
                        handleClickButton={handleChangeHistory}
                        containerStyles={{alignContent: "flex-start", width: 'auto', marginRight: 30}}
                    />
                )}
            </div>
        </div>
        <div className="row">
            <div className="X12"  style={{display: "flex", overflowX: "auto", paddingBottom: "10px"}}>
            {getListaHistorico()?.map((_historico, index, projeto_id) => {
                    return <div>
                        {[TIPO_HISTORICO_PROJETO, TIPO_HISTORICO_PEDIDO, TIPO_HISTORICO_DESCONTO, TIPO_HISTORICO_NOTA_FISCAL].includes(tipoHistorico) &&
                            <CardHistoricoNovo
                                selecionado={selectedIds.includes(_historico.historico_id) || selectedPedidosIds.includes(_historico.historico_id) || selectedDescontosIds.includes(_historico.historico_id) || selectedNotasFiscaisIds.includes(_historico.historico_id)}
                                key={index}
                                historico={_historico}
                                tipoHistorico={tipoHistorico}
                                onClick={() => {
                                    if (tipoHistorico === TIPO_HISTORICO_PROJETO) {
                                        handleChangeSelected(projeto_id[index].historico_id);
                                    } else if (tipoHistorico === TIPO_HISTORICO_PEDIDO) {
                                        handleChangeSelectedPedido(projeto_id[index].historico_id)
                                    } else if (tipoHistorico === TIPO_HISTORICO_DESCONTO) {
                                        handleChangeSelectedDesconto(projeto_id[index].historico_id)
                                    } else if (tipoHistorico === TIPO_HISTORICO_NOTA_FISCAL) {
                                        handleChangeSelectedNotaFiscal(projeto_id[index].historico_id)
                                    }
                                }}
                            />}
                    </div> 
                })}
                {getListaHistorico().length === 0 && <>
                    <div className="X12">
                        <h3>Nenhum histórico encontrado</h3>
                    </div>
                </>}
            </div>
        </div>

        {tipoHistorico === TIPO_HISTORICO_PROJETO && projetosComparaveis?.length > 0 && (
            <TabelaComparacaoProjetos dados={projetosComparaveis} changeState={changeState}/>
        )}
        {tipoHistorico === TIPO_HISTORICO_PEDIDO && pedidosComparaveis?.length > 0 && (
            <TabelaComparacaoPedidos dados={pedidosComparaveis} pedido={pedido} changeState={changeStatePedidos}/>
        )}
        {tipoHistorico === TIPO_HISTORICO_DESCONTO && descontosComparaveis?.length > 0 && (
            <TabelaComparacaoDescontos dados={descontosComparaveis} changeState={changeStateDescontos}/>
        )}
        {tipoHistorico === TIPO_HISTORICO_NOTA_FISCAL && notasFiscaisComparaveis?.length > 0 && (
            <TabelaComparacaoNotasFiscais dados={notasFiscaisComparaveis} changeState={changeStateNotasFiscais}/>
        )}

        {/* {projetoSelecionado > -1 && tipoHistorico === TIPO_HISTORICO_PROJETO  ? <HistoricoProjeto historico={historicosProjeto[projetoSelecionado]} projeto={projeto} pedido={pedido} classes={classes} /> : <></>}
        {pedidoSelecionado > -1 && tipoHistorico === TIPO_HISTORICO_PEDIDO  ? <HistoricoPedido historicoPedido={historicoPedido[pedidoSelecionado]} pedido={pedido} projeto={projeto} classes={classes}/> : <></>}
        {descontoSelecionado > -1 && tipoHistorico === TIPO_HISTORICO_DESCONTO  ? <HistoricoDesconto historicoDesconto={historicoDesconto[descontoSelecionado]} desconto={descontoAtual} classes={classes}/> : <></>}
        {notafiscalSelecionado > -1 && tipoHistorico === TIPO_HISTORICO_NOTA_FISCAL  ? <HistoricoNotaFiscal historicoNotaFiscal={historicoNotaFiscal[notafiscalSelecionado]} classes={classes}/> : <></>} */}
    </div>
}

export { HistoricoMigrado };